import { render, staticRenderFns } from "./rekonbank.vue?vue&type=template&id=9030e466&scoped=true"
import script from "./rekonbank.vue?vue&type=script&lang=js"
export * from "./rekonbank.vue?vue&type=script&lang=js"
import style0 from "./rekonbank.vue?vue&type=style&index=0&id=9030e466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9030e466",
  null
  
)

export default component.exports